// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"dbcc2f2e","393":"c908b485","607":"20899826","624":"58faa79a","651":"e3d7beb0","901":"9c13520c","919":"397dba6f"}[chunkId] + ".chunk.js";
};